export default __webpack_public_path__ + "media/images/features/saga/yoshinogari_park-cfe4c7b62f8f7315395b77d7788cc898.jpg";